import * as React from 'react';

import * as styles from './ApartmentTypeFilterWrapper.css';

interface IApartmentTypeFilterWrapperProps {
  apartmentType: React.ReactNode;
  penthouseType?: React.ReactNode;
}

export const ApartmentTypeFilterWrapper: React.FC<IApartmentTypeFilterWrapperProps> = ({
  apartmentType,
  penthouseType,
}) => {
  return (
    <div className={styles['container']}>
      {apartmentType}
      {penthouseType}
    </div>
  );
};
